// removed by extract-text-webpack-plugin


//////////////////
// WEBPACK FOOTER
// ./src/client/modules/orders/modules/orders-detail/components/order-claims/patient-waiver/patient-waiver.less
// module id = 2986
// module chunks = 0 1